var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVerticalDots = function SvgIconVerticalDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.167a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666ZM2 13a.833.833 0 1 0 0 1.667A.833.833 0 0 0 2 13ZM2 1.333A.833.833 0 1 0 2 3a.833.833 0 0 0 0-1.667Z",
    stroke: "#111927",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconVerticalDots;